<template>
  <div class="w-100">
    <Swiper ref="mySwiper" :options="swiperOptions" :auto-update="true" @slide-change="changeSwiperIndex">
      <SwiperSlide v-for="cluster in clusters" :key="cluster.id">
        <Item :cluster="cluster" />
      </SwiperSlide>
      <img
        slot="button-prev"
        class="swiper-button-prev d-none d-sm-block"
        src="@/assets/carousel/Asset_28.png"
        alt
        height="58"
        width="21"
      />
      <img
        slot="button-next"
        class="swiper-button-next d-none d-sm-block"
        src="@/assets/carousel/Asset_28_right.png"
        alt
        height="58"
        width="21"
      />
    </Swiper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Item from './ClusterItem.vue';

export default {
  name: 'ShowCluster',
  components: {
    Swiper,
    SwiperSlide,
    Item,
  },
  data() {
    return {
      swiperOptions: {
        keyboard: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        noSwiping: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          576: {
            slidesPerView: 'auto',
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    ...mapGetters({
      clusters: 'cluster/list',
      subject: 'subject/currentSubject',
      sidebar: 'app/sidebar',
    }),
  },
  watch: {
    'sidebar.isCollapsed': function () {
      this.swiper.update();
    },
  },
  created() {
    this.onFetchClusters();
  },
  methods: {
    changeSwiperIndex() {
      const clusterIndex = this.swiper.activeIndex;
      this.$store.commit('cluster/SET_CURRENT_CLUSTER', clusterIndex);
      this.$router.replace({
        name: 'subject',
        query: { cluster_id: this.clusters[clusterIndex].id },
      });
    },
    onFetchClusters() {
      this.fetchClusters({ subject_id: this.$route.params.subject_id }).then(() => {
        const clusterId = this.$route.query.cluster_id;
        if (clusterId) {
          const cluster = this.clusters.find(cluster => cluster.id === Number.parseInt(clusterId));
          if (cluster) {
            const index = this.clusters.findIndex(cluster => cluster.id === Number.parseInt(clusterId));
            this.$store.commit('cluster/SET_CURRENT_CLUSTER', index);
            this.swiper.slideTo(index, 1000, false);
            // this.$router.replace({ query: { cluster_id: cluster.id } });
          } else {
            this.$store.commit('cluster/SET_CURRENT_CLUSTER', 0);
            this.swiper.slideTo(0, 1000, false);
            this.$router.replace({ query: { cluster_id: this.clusters[0].id } });
          }
        } else {
          this.$store.commit('cluster/SET_CURRENT_CLUSTER', 0);
          this.$router.replace({ query: { cluster_id: this.clusters[0].id } });
        }
      });
    },
    ...mapActions({
      fetchClusters: 'cluster/FETCH_LIST',
    }),
  },
};
</script>

<style lang="sass" scoped>
.cluster
  background: #fff
  border-radius: 15px 15px 5px 5px
  box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4)
  margin-bottom: 1rem
  max-width: 1500px
  margin: auto
  padding-top: 15px
  position: relative
  min-height: 60vh
  width: 92%
  +forTablet
    min-height: 55vh
    width: 85%
  +forDesktop
    min-height: 70vh
    width: 85%
  &:after,
  &:before
    right: 100%
    top: 75px
    +forTablet
      top: 85px
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:after
    border-color: rgba(194, 225, 245, 0)
    border-right-color: #76791f
    border-width: 20px
    margin-top: -20px
    z-index: -1
  &:before
    border-color: rgba(194, 225, 245, 0)
    border-right-color: #76791f
    border-width: 20px
    margin-top: -20px
    z-index: -1
  +element('head')
    align-items: center
    background: #ced529
    display: flex
    margin-left: -20px
    width: 95%
    box-shadow: 4px 3px 10px rgba(0,0,0,.75)
    height: 60px
    padding-left: .5em
    +forTablet
      height: 70px
    +forDesktop
      padding-left: 2em
  +element('title')
    color: #fff
    font-family: 'latoregular'
    font-weight: bold
    line-height: 1
    margin-bottom: 0
    font-size: 1.3rem
    +forTablet
      font-size: 1.6rem
  +element('lesson-list')
    overflow-y: auto
    padding: 1em 5px 2em 5px
  +element('lesson-link')
    border-radius: 5px
    color: green
    display: flex
    align-items: center
    font-family: 'varela_roundregular'
      font-size: 1.02rem
    padding: 5px
    text-decoration: none
    transition: background-color 0.02s
    &:hover
      text-decoration: underline
    +forTablet
      font-size: 1.5em
  +element('lesson-icon')
    margin-right: 5px
    height: 25px
    width: 25px
  +element('test-link')
    align-items: center
    background: #b9b9b9
    box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4)
    display: flex
    border-radius: 5px
    height: 50px
    color: #fff
    font-family: 'varela_roundregular'
    font-size: 22px
    padding-left: 10px
    text-decoration: none
    width: 180px
    position: absolute
    right: -15px
    bottom: 25px
    +forTablet
      right: -30px
    +modifier('ready')
      background: #089d35
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.75)
      transition: transform 0.02s
      &:hover
        transform: scale(1.01)
    +modifier('disabled')
      background: grey
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5)
      pointer-events: none

.yellow
  color: #fefd2a
.swiper-container
  height: 100%
.swiper-slide
  width: 100%
</style>
